// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4888":"e8877c44","6667":"3efe7b3d"}[chunkId] + ".chunk.css";
};